module.exports = __webpack_public_path__ + "img/c5815d4a9ff6bbb5964464b4a59775ca.png";